import { apiRequest } from '@/api/request.js'
export const logout = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_auth/ma/login_out',
    method: 'POST'
  })
}
export const checkCaptcha = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_auth/ua/captcha/check',
    method: 'POST'
  })
}
export const fetchCaptcha = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_auth/ua/captcha/get',
    method: 'POST'
  })
}
export const loginByAccount = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_auth/ua/ma/login',
    method: 'POST'
  })
}
export const loginByWechatMa = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_auth/ua/three/ma/login',
    method: 'POST'
  })
}
export const loginByPublicAccount = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_auth/ua/login',
    method: 'POST'
  })
}
export const loginByPublicAccountCode = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_auth/ua/login_with_code',
    method: 'POST'
  })
}
export const loginByWechatAccount = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_auth/ua/wx/login',
    method: 'POST'
  })
}
export const loginBySocialMa = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_auth/ua/social/ma',
    method: 'POST'
  })
}
export const loginBySocialMp = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_auth/ua/social/mp',
    method: 'POST'
  })
}
export const forgetPassword = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_auth/forget_password',
    method: 'PUT'
  })
}
export const forgetPasswordPublic = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_auth/ua/forget_password',
    method: 'PUT'
  })
}
export const refreshAccessToken = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_auth/ua/token/refresh',
    method: 'POST'
  })
}
export const createWxJsapiSignature = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_auth/wx/jsapi/createJsapiSignature',
    method: 'POST'
  })
}
